import React from "react"

export function BitsGradientIcon({ h, w, className = "" }: { h?: number; w?: number; className?: string }) {
  return (
    <svg width={w} height={h} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 15.7624C14.3536 15.7624 16.2616 13.8544 16.2616 11.5008C16.2616 9.14719 14.3536 7.2392 12 7.2392C9.64639 7.2392 7.7384 9.14719 7.7384 11.5008C7.7384 13.8544 9.64639 15.7624 12 15.7624Z"
        fill="url(#paint0_linear_8468_26159)"
      />
      <path
        d="M18.4872 3.5C18.4626 3.48028 18.4343 3.4656 18.404 3.45682C18.3737 3.44803 18.342 3.44531 18.3106 3.4488C18.2792 3.45229 18.2489 3.46193 18.2213 3.47717C18.1936 3.49241 18.1693 3.51294 18.1496 3.5376L16.4 5.7256C16.3603 5.77518 16.3419 5.83847 16.3488 5.9016C16.3561 5.96457 16.388 6.02209 16.4376 6.0616C17.5916 6.98217 18.431 8.23869 18.8395 9.65727C19.2481 11.0758 19.2056 12.5863 18.7179 13.9797C18.2302 15.373 17.3215 16.5804 16.1175 17.4346C14.9136 18.2888 13.4738 18.7476 11.9976 18.7476C10.5214 18.7476 9.08164 18.2888 7.87766 17.4346C6.67367 16.5804 5.76497 15.373 5.27731 13.9797C4.78965 12.5863 4.74714 11.0758 5.15567 9.65727C5.5642 8.23869 6.40356 6.98217 7.5576 6.0616C7.60717 6.02209 7.63909 5.96457 7.6464 5.9016C7.65329 5.83847 7.63488 5.77518 7.5952 5.7256L5.8504 3.5376C5.83072 3.51294 5.80637 3.49241 5.77874 3.47717C5.75111 3.46193 5.72075 3.45229 5.6894 3.4488C5.65804 3.44531 5.6263 3.44803 5.596 3.45682C5.5657 3.4656 5.53743 3.48028 5.5128 3.5C4.28951 4.47224 3.30207 5.70868 2.62446 7.1167C1.94684 8.52472 1.59661 10.0678 1.6 11.6304C1.6 17.3656 6.2664 22.0304 12 22.0304C17.7336 22.0304 22.4 17.364 22.4 11.6304C22.4034 10.0678 22.0532 8.52472 21.3755 7.1167C20.6979 5.70868 19.7105 4.47224 18.4872 3.5Z"
        fill="url(#paint1_linear_8468_26159)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8468_26159"
          x1="12"
          y1="7.24"
          x2="12"
          y2="15.7624"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#A866FF" />
          <stop offset="1" stopColor="#EA4EF5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8468_26159"
          x1="-1.21288e-07"
          y1="3.4472"
          x2="0.0799999"
          y2="22.032"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#A866FF" />
          <stop offset="1" stopColor="#EA4EF5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
